export const facultyOption = [
    {
      value: "Aquatic Resources Research Institute",
      label: "Aquatic Resources Research Institute",
    },
    {
      value: "Asian Studies Institute",
      label: "Asian Studies Institute",
    },
    {
      value: "Biotechnology and Genetic Engineering Institute",
      label: "Biotechnology and Genetic Engineering Institute",
    },
    {
      value: "College of Population Studies",
      label: "College of Population Studies",
    },
    {
      value: "Energy Research Institute",
      label: "Energy Research Institute",
    },
    {
      value: "Environmental Research Institute",
      label: "Environmental Research Institute",
    },
    {
      value: "Faculty of Allied Health Sciences",
      label: "Faculty of Allied Health Sciences",
    },
    {
      value: "Faculty of Architecture",
      label: "Faculty of Architecture",
    },
    {
      value: "Faculty of Arts",
      label: "Faculty of Arts",
    },
    {
      value: "Faculty of Commerce and Accountancy",
      label: "Faculty of Commerce and Accountancy",
    },
    {
      value: "Faculty of Communication Arts",
      label: "Faculty of Communication Arts",
    },
    {
      value: "Faculty of Dentistry",
      label: "Faculty of Dentistry",
    },
    {
      value: "Faculty of Economics",
      label: "Faculty of Economics",
    },
    {
      value: "Faculty of Education",
      label: "Faculty of Education",
    },
    {
      value: "Faculty of Engineering",
      label: "Faculty of Engineering",
    },
    {
      value: "Faculty of Fine and Applied Art",
      label: "Faculty of Fine and Applied Art",
    },
    {
      value: "Faculty of Law",
      label: "Faculty of Law",
    },
    {
      value: "Faculty of Medicine",
      label: "Faculty of Medicine",
    },
    {
      value: "Faculty of Nursing",
      label: "Faculty of Nursing",
    },
    {
      value: "Faculty of Pharmaceutical Sciences",
      label: "Faculty of Pharmaceutical Sciences",
    },
    {
      value: "Faculty of Political Science",
      label: "Faculty of Political Science",
    },
    {
      value: "Faculty of Psychology",
      label: "Faculty of Psychology",
    },
    {
      value: "Faculty of Science",
      label: "Faculty of Science",
    },
    {
      value: "Faculty of Sport Science",
      label: "Faculty of Sport Science",
    },
    {
      value: "Faculty of Veterinary Science",
      label: "Faculty of Veterinary Science",
    },
    {
      value: "Language Institute",
      label: "Language Institute",
    },
    {
      value: "Metallurgy and Materials Science Research Institute",
      label: "Metallurgy and Materials Science Research Institute",
    },
    {
      value:
        "Sasin Graduate Institute of Business Administration of Chulalongkorn University",
      label:
        "Sasin Graduate Institute of Business Administration of Chulalongkorn University",
    },
    {
      value: "Social Research Institute",
      label: "Social Research Institute",
    },
    {
      value: "Thai Studies Institute",
      label: "Thai Studies Institute",
    },
    {
      value: "The College of Public Health Science",
      label: "The College of Public Health Science",
    },
    {
      value: "The Petroleum and Petrochemical College",
      label: "The Petroleum and Petrochemical College",
    },
    {
      value: "The School of Agricultural Resource",
      label: "The School of Agricultural Resource",
    },
    {
      value: "Transportation Institute",
      label: "Transportation Institute",
    },
  ];